import type { Selected } from './index.h'

import { combine, createEvent, createStore } from 'effector'
import { epgChannelsModel } from '~/entities/epg/channels'
import { epgProgramsModel, NO_EPG_ID } from '~/entities/epg/programs'
import { isSameSelected } from './lib'

export const select = createEvent<Selected>()
export const deselect = createEvent()
export const $selected = createStore<Selected | null>(null)
  .reset(deselect)
  .on(select, (current, selected) =>
    isSameSelected(current)(selected) ? current : selected
  )

// currently selected channel with program
export const $program = combine(
  {
    selected: $selected,
    all: epgChannelsModel.$all,
    epg: epgProgramsModel.$epg,
  },
  ({ selected, all: [channels], epg: [programs] }) => {
    if (selected == null) return null

    const channel = channels.get(selected.channelId)
    if (channel == null) return null

    const program = programs.get(channel.epgId ?? NO_EPG_ID)
    if (program == null) return null

    const chosen = program.find((p) => p.id === selected.programId)
    if (chosen == null) return null

    return { channel, program: chosen }
  }
)
